namespace Matrix.Rebalancer {
    export class TradeMacroColumns {
        static columnsKey = 'Rebalancer.TradeMacro';
    }
}
